export default __webpack_public_path__ + "static/media/model-x.5259e95a.png";